import BaseStep from "./baseStep";
import styles from "./styles.module.scss";
import { ISelectItem, Select } from "../../../ui/select";
import { useEffect, useState } from "react";
import {
  getFacilityTypes,
  getFacilityTypesConnection,
} from "../../../../lib/utils";
import useFacilityType from "../../../../api/hooks/use-facility-type";
import Loader from "../../../ui/loader";
import { CheckBox } from "../../../ui/checkbox/checkboxMain";
import { ICounterPage } from "./types";

interface IFacilityTypeStep {
  isNextStepDisabled: boolean;
  data: number[] | null;
  text?: string;
  numPage?: number;
  mode: "default" | "repeat";
  onChange: (selectedId: number) => void;
  onNextStep: () => void;
  onPrevStep: () => void;
  counterPage?: ICounterPage;
}

const FacilityTypeStep_2 = ({
  isNextStepDisabled,
  data,
  text,
  onChange,
  onNextStep,
  onPrevStep,
  mode,
  counterPage,
}: IFacilityTypeStep) => {
  const [isStudio, setIsStudio] = useState(false);

  const handleChangeStudio = (value: boolean, type: "studio" | "default") => {
    if (type === "default") {
      setIsStudio(!value);
    } else {
      setIsStudio(value);
    }
  };

  const { facilityTypeList, isLoading } = useFacilityType();

  const [selected, setSelected] = useState<ISelectItem>();

  const handleChange = (itemId: number, option: ISelectItem) => {
    setSelected(option);
  };

  const planFounded =
    data && facilityTypeList?.find((type) => type.id === data[0]);
  const planOption = planFounded && {
    key: planFounded?.id,
    label: planFounded?.fullTitle,
  };

  let transformPlans =
    selected && mode === "default"
      ? getFacilityTypes(selected, data, facilityTypeList, true, onChange)
      : planOption &&
        getFacilityTypesConnection(
          planOption,
          data,
          facilityTypeList,
          onChange
        );

  transformPlans = transformPlans?.filter((data) => {
    return !data.label.includes("студия");
  });

  const textMode = text
    ? text
    : mode === "default"
    ? "Сколько комнат в квартире необходимо?"
    : "Выбирите один из аналогов";

  if (isLoading) {
    return (
      <div className={styles.loader}>
        <Loader />
      </div>
    );
  }

  if (!facilityTypeList.length) {
    return (
      <div className={styles.errorLoadedData}>
        Ошибка загрузке данных попробуйте позже
      </div>
    );
  }

  const menuArray = facilityTypeList
    ?.filter((type) => {
      return !type.isStudio;
    })
    ?.map((type) => {
      return {
        key: type.id,
        label: type.fullTitle,
      };
    })
    ?.filter((type) => type !== undefined);

  useEffect(() => {
    if (selected) {
      if (!isStudio) {
        onChange(selected?.key);
      } else {
        const sameData = selected?.label.toString().split(" ")[0];

        let newItem = facilityTypeList.find(
          (itemList) =>
            itemList.isStudio &&
            itemList.fullTitle.toString().split(" ")[0] === sameData
        );

        if (newItem?.id) {
          onChange(newItem?.id);
        }
      }
    }
  }, [selected, isStudio]);

  return (
    <div className={styles.facilityTypeStep}>
      <BaseStep
        counterPage={counterPage}
        nextStep={onNextStep}
        prevStep={onPrevStep}
        text={textMode}
        isNextStepDisabled={isNextStepDisabled}
      >
        <div>
          {!isLoading && menuArray.length && mode === "default" && (
            <div className={styles.facilityTypeStep__select}>
              <Select
                onSelect={handleChange}
                selected={
                  selected
                    ? selected.key
                    : handleChange(
                        menuArray[0].key,
                        menuArray[0] as ISelectItem
                      )
                }
                multiple={false}
                menuArray={menuArray as ISelectItem[]}
              />
            </div>
          )}
          <div className={styles.facilityTypeStep__checkBoxes}>
            <CheckBox
              label="Кухня объединена с гостиной"
              checked={isStudio}
              onChange={(value) => handleChangeStudio(value, "studio")}
            />
            <CheckBox
              label="Кухня отдельное помещение"
              checked={!isStudio}
              onChange={(value) => handleChangeStudio(value, "default")}
            />
          </div>
        </div>
      </BaseStep>
    </div>
  );
};

export default FacilityTypeStep_2;
